import { formatLocale } from "../../../helpers/formatLocale";

const TARGET_RENTERS = [
  'Tourists & Sightseers',
  'Business Travelers',
  'City Dwellers Without Cars',
  'Students & Young Adults',
  'Emergency Renters'
];

const formatTravelReason = (targetRenters) => {
  if (targetRenters === "Others") {
    return "for personal reasons";
  } else if (targetRenters === 'All') {
    return TARGET_RENTERS.join(', ');
  }
  return targetRenters;
};

export const ownerPrompt = {

  carTitleDescription: ({ location, carFeatures, carDetails, lang, targetRenters }) => {
    const finalReason = formatTravelReason(targetRenters);
    const isAll = targetRenters === 'All';
    return `
  You are an expert rental car copywriter.
  Write one short, catchy title (≤10 words) and one detailed, engaging description (80–120 words) for a rental car listing.
  Details:
  ${location ? `- Location: ${location}` : ''}
  ${carFeatures ? `- Car Features: ${carFeatures}` : ''}
  ${carDetails ? `- Car Details: ${carDetails}` : ''}
  - Target Renters: ${finalReason}
  Language: ${formatLocale(lang)}
  Rules:
  1. Title: ≤10 words, catchy, highlight the best feature.
  2. Description: 80–120 words, friendly and engaging.
  3. Mention only available details (location, carFeatures, carDetails).
  4. ${isAll
        ? `The car appeals to ALL renter types (${finalReason}). Write a universally appealing title and description that resonates across all these audiences.`
        : `Tailor the tone specifically for: ${finalReason}. Choose a tone that fits — professional, casual, luxury, family, or business.`
      }
  5. Do not invent or assume extra info.
  6. Output only JSON: { "title": "...", "description": "..." }
    `;
  },


  carRentPriceEstimation: ({ location, carType, make, model, year, carFeatures, currency }) => {
    const featuresText = carFeatures && carFeatures.trim() ? carFeatures : 'Not specified';
    return `You are an expert car rental pricing engine with deep knowledge of global rental markets.

Price this car for daily rental:
- Location: ${location}
- Type: ${carType}
- Make: ${make} ${model} (${year})
- Features: ${featuresText}
- Currency: ${currency}

Using your knowledge of current rental markets in ${location}, return a realistic
daily price range a customer would actually pay.

PRICING LOGIC:
- Price natively in ${currency} using local market rates, not USD converted
- min_price = typical off-peak / advance booking rate
- max_price = peak season / last-minute / weekend rate
- The spread between min and max should reflect realistic demand volatility:
    - Economy/Compact: max is 1.3x–1.5x of min
    - Mid-size/SUV: max is 1.5x–1.7x of min
    - Luxury/Premium: max is 1.7x–2.5x of min
- Round both values to the nearest 5 or 10
- If any field is not specified, use best judgment based on available details

Output only JSON:
{ "min_price": number, "max_price": number, "currency": "${currency}" }`;
  }
}
